/**
 * /daily-backup — migrated from public/js/daily-backup.js.
 * Rotator de title-uri in .site-box h3 span — cycle la fiecare 3 secunde.
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    const title = $('.site-box h3 span', true);
    const interval = 3; // seconds
    let index = 0;

    setInterval(() => {
        title.item(index++)?.classList.add('hide');
        if (index + 1 === title.length) index = 0;
        title.item(index)?.classList.remove('hide');
    }, interval * 1000);
});
